import { format } from "date-fns";
import { EmailDeliveryFailure } from "../api/types";

export const isEmailSuppressed = (failure?: EmailDeliveryFailure | null) => failure?.status === "SUPPRESSED";

export const emailDeliveryFailureTooltip = (failure: EmailDeliveryFailure) =>
  isEmailSuppressed(failure)
    ? "Email could not be delivered – the address is blocked by the mail provider."
    : "The last email to this address could not be delivered.";

export const emailDeliveryFailureType = (failure: EmailDeliveryFailure) =>
  failure.eventType === "COMPLAINT" ? "Complaint (marked as spam)" : "Bounce";

export const emailDeliveryFailureReason = (failure: EmailDeliveryFailure) => {
  if (failure.eventType === "COMPLAINT") return failure.complaintFeedbackType || "Recipient reported the email as spam";

  const parts = [failure.bounceType, failure.bounceSubType].filter(Boolean);
  if (failure.bounceSubType === "OnAccountSuppressionList") return "Address was already on the suppression list";
  return parts.length ? parts.join(" / ") : "Unknown";
};

// The backend sends a LocalDateTime in UTC without a zone designator.
export const formatEmailDeliveryFailureDate = (eventAt: string) => {
  const iso = /(Z|[+-]\d{2}:?\d{2})$/.test(eventAt) ? eventAt : `${eventAt}Z`;
  const date = new Date(iso);
  return isNaN(date.getTime()) ? eventAt : format(date, "dd/MM/yyyy HH:mm");
};
